if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      const peekMode = this.closest(".m-slider--peek");
      const slideCount =
        this.sliderContainer.querySelector(".swiper-wrapper")?.childElementCount || 0;

      const sliderOptions = {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerGroup: 1,
        loop: slideCount > 1,
        speed: peekMode ? 600 : 1000,
        navigation:
          this.showArrows && !peekMode
            ? {
                nextEl: this.querySelector(".m-slider-controls__button-next"),
                prevEl: this.querySelector(".m-slider-controls__button-prev"),
              }
            : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      };

      if (peekMode) {
        Object.assign(sliderOptions, {
          slidesPerView: 1.15,
          centeredSlides: true,
          spaceBetween: 6,
          loopedSlides: slideCount,
          loopAdditionalSlides: slideCount,
          threshold: 15,
          preventClicks: true,
          preventClicksPropagation: true,
          slideToClickedSlide: false,
          breakpoints: {
            768: {
              slidesPerView: 1.15,
              centeredSlides: true,
              spaceBetween: 6,
              loopedSlides: slideCount,
              loopAdditionalSlides: slideCount,
            },
            1025: {
              slidesPerView: 1.15,
              centeredSlides: true,
              spaceBetween: 15,
              loopedSlides: slideCount,
              loopAdditionalSlides: slideCount,
            },
          },
        });
      } else {
        Object.assign(sliderOptions, {
          slidesPerView: 1,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          breakpoints: {
            992: {
              threshold: 2,
            },
          },
        });
      }

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, sliderOptions);

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (peekMode && this.showArrows) {
        const prevBtn = this.querySelector(".m-slider-controls__button-prev");
        const nextBtn = this.querySelector(".m-slider-controls__button-next");
        prevBtn?.addEventListener("click", () => this.slider.slidePrev());
        nextBtn?.addEventListener("click", () => this.slider.slideNext());
      }

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
